"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.TYPE = void 0;
exports.TYPE = 'downloader';
exports.DEFAULT_VALUE = {
    label: null,
    file: null,
};
